import { Store, ArrowUpRight } from "lucide-react";
import { Reveal, WhatsAppIcon } from "./Extras";
import { B2B_URL, buildWhatsAppUrl } from "../data/content";

const B2B = ({ config }) => (
    <section id="distribuidores" data-testid="b2b-section" className="bg-brand-cream pb-12 md:pb-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <Reveal>
                <div className="relative overflow-hidden rounded-[2rem] bg-brand-purple px-6 py-10 shadow-lift sm:px-12 md:py-14">
                    <div
                        className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-brand-magenta/25 blur-3xl"
                        aria-hidden="true"
                    />
                    <div className="relative grid items-center gap-8 lg:grid-cols-[1.2fr_1fr]">
                        <div>
                            <span className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-xs font-bold uppercase tracking-widest text-white">
                                <Store className="h-4 w-4" /> Para negocios
                            </span>
                            <h2 className="mt-5 font-display text-3xl font-bold tracking-tight text-white sm:text-4xl">
                                ¿Tienes una veterinaria o pet shop? Vende LoloPets
                            </h2>
                            <p className="mt-4 max-w-lg text-base leading-relaxed text-white/75">
                                Sumá a tu negocio una marca europea de nutrición premium para mascotas
                                pequeñas, con catálogo completo y respaldo de Tugeko S.A. Llena el
                                formulario y pronto estaremos contactándote.
                            </p>
                        </div>
                        <div className="flex flex-col gap-3 lg:items-end">
                            <a
                                data-testid="b2b-cta-form"
                                href={B2B_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex min-h-[44px] items-center justify-center gap-2 rounded-full bg-brand-magenta px-8 py-3 font-display font-bold text-white transition-all duration-300 hover:-translate-y-0.5 hover:bg-brand-magentadark hover:shadow-lift"
                            >
                                Quiero ser distribuidor <ArrowUpRight className="h-4 w-4" />
                            </a>
                            <a
                                data-testid="b2b-cta-whatsapp"
                                href={buildWhatsAppUrl(config?.whatsapp, "Hola, tengo una veterinaria/pet shop y quiero vender LoloPets.")}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex min-h-[44px] items-center justify-center gap-2 rounded-full border-2 border-white/25 px-8 py-3 font-display font-semibold text-white transition-all duration-300 hover:-translate-y-0.5 hover:border-white/60"
                            >
                                <WhatsAppIcon className="h-4 w-4" /> Escribir por WhatsApp
                            </a>
                        </div>
                    </div>
                </div>
            </Reveal>
        </div>
    </section>
);

export default B2B;
